import React from "react";
import { DEFAULT_PREVIEW_ATTRS, PreviewAttrsSchema } from "./api";
import type { PreviewAttrs } from "./api";

const STORAGE_KEY = `healthForms.previewAttrs:${process.env.REACT_APP_API_URL_V2 ?? "default"}`;

const load = (): PreviewAttrs => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_PREVIEW_ATTRS;
    const result = PreviewAttrsSchema.safeParse(JSON.parse(raw));
    return result.success ? result.data : DEFAULT_PREVIEW_ATTRS;
  } catch {
    return DEFAULT_PREVIEW_ATTRS;
  }
};

const save = (attrs: PreviewAttrs) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(attrs));
  } catch {
    // ignore quota / disabled storage
  }
};

export const usePersistedPreviewAttrs = (): [PreviewAttrs, React.Dispatch<React.SetStateAction<PreviewAttrs>>] => {
  const [attrs, setAttrs] = React.useState<PreviewAttrs>(load);
  React.useEffect(() => {
    save(attrs);
  }, [attrs]);
  return [attrs, setAttrs];
};
